// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class PastActivationsResource extends Resource {
    basePath: string = 'cases/alarms/';

    objectPath: string = 'cases/alarms/{ident}/';
}
